import React from "react";
import { getStrValue } from "../../../store/utility";
import { Form, Button, FormGroup } from "react-bootstrap";

import moment from "moment";

export default class ClientResponseTab extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      plannedDate:
        this.props.request.predictedAt === null
          ? moment()
          : moment(this.props.request.predictedAt, "DD/MM/YYYY"),
      predictedDate: this.props.request.predictedAt,
      interventionDate:
        this.props.request.executedAt === null
          ? null
          : moment(this.props.request.executedAt, "DD/MM/YYYY"),
      request: this.props.request,
      requestMessage: this.props.requestMessage,
      message:
        this.props.requestMessage !== null
          ? this.props.requestMessage.message
          : ""
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.request !== nextProps.request) {
      var _state = this.state;
      _state.plannedDate =
        nextProps.request.predictedAt === null
          ? moment()
          : moment(nextProps.request.predictedAt, "DD/MM/YYYY");
      _state.predictedDate = nextProps.request.predictedAt;
      _state.interventionDate =
        nextProps.request.executedAt === null
          ? null
          : moment(nextProps.request.executedAt, "DD/MM/YYYY");
      _state.request = nextProps.request;
      _state.requestMessage = nextProps.requestMessage;
    }
  }

  inputResponseChangeHandler = event => {
    this.setState({
      message: event.target.value
    });
  };
  submitHandler = () => {
    var requestMessage = {
      message: this.state.message
    };
    this.props.sendMessageToAtis(requestMessage);
  };
  validateForm() {
    return this.state.message.length > 0;
  }
  validateResponse() {
    return this.state.message.length > 0;
  }
  render() {
    return (
      <Form onSubmit={this.submitHandler} horizontal>
        <FormGroup>
          <textarea
            rows={7}
            className="form-control note-editor"
            disabled={this.state.requestMessage && this.state.requestMessage.id}
            value={getStrValue(this.state.message)}
            onChange={this.inputResponseChangeHandler}
          />
        </FormGroup>
        {this.state.requestMessage === null ? (
          <Button
            type="submit"
            disabled={!this.validateForm()}
            className="btn btn-block btn-primary mt-lg"
          >
            <span className="fa fa-send" />
            &nbsp;Envoyer
          </Button>
        ) : null}
      </Form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Request/Tab/ClientResponseTab.js